/**
 * Created by chenzheyu on 2017/6/13.
 */

import XkrecordOrderMod from './src/recordOrderMod.vue'

XkrecordOrderMod.install = function (Vue) {
  Vue.component(XkrecordOrderMod.name, XkrecordOrderMod)
}

export default XkrecordOrderMod



// WEBPACK FOOTER //
// ./src/components/module/recordOrderMod/index.js